import React from 'react';
import PropTypes from 'prop-types';

import FileSystemEntry from './file-system-entry';

import I18n from '@app/modules/i18n';

import { getDeepSubItems } from '@app/helper/transfer-items';

import Icon from '@app/component/icon';

const IconAndType = (
  <React.Fragment>
    <Icon type="Folder" width={9} height={7} />
    <span className="directory__type-detail">
      {I18n.t('transfer.item.details.folder')}
    </span>
  </React.Fragment>
);

const Directory = ({ item, actions }) => {
  const details = [
    IconAndType,
    I18n.t('transfer.items', { count: getDeepSubItems(item).length }),
  ];

  return (
    <FileSystemEntry title={item.name} details={details} actions={actions} />
  );
};

Directory.propTypes = {
  item: PropTypes.object.isRequired,
  actions: PropTypes.node,
};

export default React.memo(Directory);
